import styles from "./customer_photo.module.css";

const CustomerPhoto = ({ customer }) => {
  const img_base_url = `${window.location.protocol}//${window.location.hostname}:8443`;
  const initialName = customer?.name
    ?.split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return customer?.logo ? (
    <img
      className={styles.img}
      src={img_base_url + customer?.logo}
      alt="customer_logo"
    />
  ) : (
    <div className={`${styles.img} ${styles.nameImg}`}>
      <p>{initialName}</p>
    </div>
  );
};

export default CustomerPhoto;
